import { camelizeKeys } from 'humps';
import { FILTER_ALL_VALUE } from '@namespace/common';
import {
  getAsJson,
  postAsUriParameters,
  validateScheme
} from '@namespace/helpers';
import {
  FormattedGetHistoryResponse,
  GetHistoryParams,
  GetHistoryRequestBody,
  GetHistoryResponse,
  GetUsedSidListResponse,
  GetUsedSidListSchema
} from './types';

export const getUsedSidList = (userId: number) =>
  getAsJson<GetUsedSidListResponse>(
    `/accounting/api/v1/users/${userId}/last-used-services`
  ).then((data) => {
    validateScheme(GetUsedSidListSchema, data, { name: 'getUsedSidList' });
    return data.response;
  });

export const getHistory = ({
  amount,
  startDate,
  endDate,
  wallet,
  page,
  status,
  paymentServicesFilter = [],
  move
}: GetHistoryParams) => {
  let body = {
    move,
    page,
    amount: amount === FILTER_ALL_VALUE ? '' : amount,
    status: status === FILTER_ALL_VALUE ? '' : status,
    dt_start: startDate,
    dt_end: endDate,
    wallet_hash: ''
  } as GetHistoryRequestBody;

  if (wallet && wallet !== FILTER_ALL_VALUE) {
    body = {
      ...body,
      service_id: wallet
    };
  } else {
    body = {
      ...body,
      service_id: paymentServicesFilter.map(({ value }) => value)
    };
  }

  return postAsUriParameters<GetHistoryResponse>(
    '/accounting/api/history',
    body,
    true
  ).then(({ response: balanceHistory, page: currentPage, total: totalPages }) =>
    camelizeKeys<FormattedGetHistoryResponse>({
      data: balanceHistory,
      page: currentPage,
      totalPages
    })
  );
};

export const getDepositHistory = (data: GetHistoryParams) =>
  getHistory({
    ...data,
    move: 0
  });

export const getWithdrawHistory = (data: GetHistoryParams) =>
  getHistory({
    ...data,
    move: 1
  });
